/**
 * "Today from the Mystics" (mystic-page 2026-10-29, OUTLINE decision 9;
 * API.md §5): the pure bits of the drops row and its See all feed.
 */
const DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']

/** The feed's line under its title: "Thursday, October 29 · Your Mystics first". */
export function dropsDateLine (iso) {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(iso || ''))
  if (!m) return 'Your Mystics first'
  const d = new Date(Date.UTC(+m[1], +m[2] - 1, +m[3]))
  return `${DAYS[d.getUTCDay()]}, ${MONTHS[d.getUTCMonth()]} ${d.getUTCDate()} · Your Mystics first`
}

/** The rows the polaroids draw, tolerant of a partial payload; never a drop without a Mystic. */
export function dropCards (body) {
  const list = (body && Array.isArray(body.drops)) ? body.drops : []
  return list
    .filter((d) => d && d.mystic && d.mystic.sub_domain)
    .map((d) => ({
      sub: d.mystic.sub_domain,
      name: d.mystic.name || '',
      portrait: d.mystic.portrait || '',
      title: d.title || '',
      line: d.line || '',
      image: d.preview_image_url || d.image_url || '',
      keep: d.keep || null,
      kept: !!d.kept,
      yours: !!d.yours,
      key: `${d.mystic.sub_domain}:${d.drop_date || ''}`,
    }))
}
